/**
 * Ksting
 *
 * Copyright © 2017 Chris Andersson <chris@wbisbi.com>. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

import React, { Component } from 'react';
import { shape, string, object, bool, array, func } from 'prop-types';
import { connect } from 'react-redux';

import p from 'polyglot/polyglot';

import { updateProfile as updateProfileAction } from 'actions/user';

import { makeUpdateProfileForm } from 'selectors/updateProfileForm';

import { createUrl } from 'utils/urlHelper';

import Form from 'components/Form/Form';
import Button from 'components/Button/Button';
import Title from 'components/Title/Title';
import Admin from 'components/Admin/Admin';

import styles from './edit.scss';

/**
 * This is the Edit component.
 *
 * @author Chris Andersson <chris@wbisbi.com>
 */
export class Edit extends Component {
  /**
   * Declare expected prop types.
   *
   * @type {object}
   */
  static propTypes = {
    auth: shape({
      token: string.isRequired,
      impersonation_token: string,
    }).isRequired,
    user: shape({
      type: string.isRequired,
    }).isRequired,
    profileForm: shape({
      fieldsets: array.isRequired,
      validationMessages: object.isRequired,
      submitText: string.isRequired,
      sending: bool.isRequired,
      errors: object.isRequired,
    }).isRequired,
    updateProfile: func,
  };

  updateProfile = data => {
    const {
      auth: { token },
      user: { type },
      updateProfile,
    } = this.props;

    const emailInPayload = data?.email;
    const emailForAuthedUser = this?.props?.auth?.provider?.email;

    // If this is the case => impersonated user
    if (emailInPayload != emailForAuthedUser) {
      console.log('impersonation request!');
    }

    updateProfile(token, { ...data, role_type: type });
  };

  /**
   * Render Edit.
   *
   * @return {Object}
   */
  render() {
    const { user, profileForm } = this.props;

    return (
      <article className={styles.row}>
        <div className={styles.content}>
          <header className={styles.header}>
            <Title large title={p.t('profile.title')} />

            {user.is_talent && (
              <Button small dark ghost path={createUrl('profile', user.slug)}>
                {p.t('account.menu.view_profile')}
              </Button>
            )}
          </header>

          <section className={styles.section}>
            <Form
              {...profileForm}
              onSubmit={this.updateProfile}
              blockNavigation
            />
          </section>

          <section className={styles.section}>
            <h1 className={styles.title}>{p.t('profile.password.title')}</h1>
            <p className={styles.description}>
              {p.t('profile.password.description')}
            </p>

            <Button path={createUrl('passwordReset')} small>
              {p.t('profile.password.button_text')}
            </Button>
          </section>

          {user.show_admin && (
            <section className={styles.section}>
              <Admin />
            </section>
          )}
        </div>
      </article>
    );
  }
}

/**
 * Map state from redux store to props.
 */
const makeMapStateToProps = () => {
  const updateProfileForm = makeUpdateProfileForm();
  const mapStateToProps = (state, props) => {
    return {
      auth: state.auth,
      user: state.user,
      profileForm: updateProfileForm(state, props),
    };
  };
  return mapStateToProps;
};

export default connect(makeMapStateToProps, {
  updateProfile: updateProfileAction,
})(Edit);
